import { availableLocales } from '../gettext';

export const extractLocale = (searchParams: Record<string, string>): { locale?: string } => {
  let locale;

  const first = searchParams['lang'];
  if (availableLocales.includes(first)) {
    locale = first;
  }

  return { locale };
};
